﻿<script>
	import { fade } from "svelte/transition";
</script>
<!-- Fading is causing one of the pages not being removed properly when navigation(foo) is called in Confirmation.svelte -->
<!-- <section in:fade={{ duration: 500 }} out:fade={{ duration: 0 }}>
	<slot></slot>
</section> -->

<section>
	<slot></slot>
</section>
